import { selectIsLoading } from 'containers/Login/loginSlice'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { getsharedinfo } from 'rest/urls'
import { useReduxSelector } from 'store'
import { POST } from 'rest/request'

interface Data {
  object: string
  id: string
  address: string
  number: string
  needPin: boolean
  placeId?: string
  placeGps?: string[]
  functions: string[]
  states: DataStates
  gates: warehouse.ObjectStateGates
  gateways: warehouse.ObjectStateGateways
  actions: warehouse.OpeningClosingActions
}

interface DataStates {
  door: warehouse.WarehouseDoorState
  lock: warehouse.WarehouseLockState
}

const useData = () => {
  const { hash } = useParams<{ hash: string }>()
  const [isLoading, setLoading] = useState(false)
  const isAuthLoading = useReduxSelector(selectIsLoading)
  const [data, setData] = useState<Data | null>(null)

  const getData = async (_hash: string) => {
    setLoading(true)
    try {
      const response: Data = await POST(getsharedinfo, { body: { hash: _hash } })
      if (response) {
        setLoading(false)
        setData(response)
      } else {
        throw new Error('Wrong response')
      }
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!isAuthLoading && hash) getData(hash)
  }, [hash, isAuthLoading])
  return {
    isLoading,
    data
  }
}

export default useData